import {Component, inject, OnInit} from '@angular/core';
import {
    MAT_DIALOG_DATA,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogRef,
    MatDialogTitle
} from '@angular/material/dialog';
import {FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {HydraService} from '../../../core/services/hydra.service';
import {api} from '../../../api/api-dictionnary';
import {AuthentificationService} from '../../../core/services/authentification.service';
import {Contact} from '../../../interface/api/Contact';
import {HydraCollection} from '../../../class/generic/hydra-collection';
import {Utilisateur} from "../../../class/api/Utilisateur";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {MatSelect} from '@angular/material/select';
import {MatOption} from '@angular/material/core';
import {ControlsMessagesComponent} from '../controls-messages/controls-messages.component';

import {MatButton} from '@angular/material/button';
import {ToolsService} from "../../services/tools/tools.service";

@Component({
    selector: 'app-modal-contact',
    templateUrl: './modal-contact.component.html',
    styleUrls: ['./modal-contact.component.scss'],
    imports: [FormsModule, ReactiveFormsModule, MatDialogTitle, MatDialogContent, MatSelect, MatOption, ControlsMessagesComponent, MatDialogActions, MatButton, MatDialogClose, TranslateModule]
})
export class ModalContactComponent implements OnInit {
    dialogRef = inject<MatDialogRef<ModalContactComponent>>(MatDialogRef);
    private hydraService = inject(HydraService);
    private authService = inject(AuthentificationService);
    private translateService = inject(TranslateService);
    private toolsService = inject(ToolsService);

    data = inject<{
        title?: string;
        contactAAP?: Utilisateur;
    }>(MAT_DIALOG_DATA);


    public form: FormGroup;
    public contacts: Contact[] = [];
    public title = '';
    public contactAAP: Utilisateur | null = null;

    constructor() {
        const data = this.data;

        if (data?.title) {
            this.title = data.title;
        } else {
            this.title = this.translateService.instant('general.contact');
        }

        if (data?.contactAAP) {
            this.contactAAP = data.contactAAP;
        }
    }

    createForm() {
        this.form = new FormGroup({
            message: new FormControl<string>('', [Validators.required]),
            email: new FormControl<string>('', [Validators.required, Validators.email]),
            nom: new FormControl<string>('', [Validators.required]),
            prenom: new FormControl<string>('', [Validators.required]),
            contact: new FormControl<string | Utilisateur>(this.contactAAP, [Validators.required]),
            civilite: new FormControl<string>('', [Validators.required, Validators.pattern('[MF]')]),
        });

        if (this.authService.userConnected) {
            this.form.patchValue({
                nom: this.authService.userConnected.nom,
                prenom: this.authService.userConnected.prenom,
                email: this.authService.userConnected.email,
                civilite: this.authService.userConnected.civilite,

            });
        }

        this.hydraService.getList(api.contacts + '?actif=true').subscribe(
            (res: HydraCollection) => {
                this.contacts = res.getMember();
            }
        );
    }

    onSubmit() {
        if (!this.form.valid) {
            return;
        }

        this.hydraService.post(
            api.contactEmailRequest,
            {...this.form.value}
        ).subscribe(
            {
                next: () => {
                    this.dialogRef.close();
                },
                error: (err) => {
                    this.toolsService.notificationError(err.error['hydra:description'] ?? 'Une erreur est survenue. Merci de réessayer plus tard');
                }
            }
        );

    }


    ngOnInit() {
        this.createForm();
    }
}
